var Vendd = (function (Vendd) {
    'use strict';

    Vendd.WishlistArticle = (function (WishlistArticle) {

        WishlistArticle.Messages = (function (Messages) {

        Messages.Add = function (id, path, extraAttributes, bundleItems) {
            var data = {
                id: id,
                path: path,
                extraAttributes: extraAttributes, //example: extraAttributes: [{code:'test',value:'testValue'}]
                bundleItems: bundleItems //example: bundleItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistArticle.Messages.Add", data);
        };
        Messages.Add.className = "Vendd.WishlistArticle.Messages.Add";

        Messages.AddSuccess = function (response) {
            response.data = JSON.parse(response.data);
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistArticle.Messages.AddSuccess', response);
        };
         Messages.AddSuccess.className = 'Vendd.WishlistArticle.Messages.AddSuccess';

        Messages.Remove = function (id) {
            var data = {
                id: id
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistArticle.Messages.Remove", data);
        };
        Messages.Remove.className = "Vendd.WishlistArticle.Messages.Remove";

        Messages.Clear = function () {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistArticle.Messages.Clear");
        };
        Messages.Clear.className = "Vendd.WishlistArticle.Messages.Clear";

        Messages.Changed = function (model) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistArticle.Messages.Changed', model);
        };
        Messages.Changed.className = 'Vendd.WishlistArticle.Messages.Changed';

        Messages.GetModel = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistArticle.Messages.GetModel');
        };
        Messages.GetModel.className = 'Vendd.WishlistArticle.Messages.GetModel';

        Messages.Failed = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistArticle.Messages.Failed', response);
        };
        Messages.Failed.className = 'Vendd.WishlistArticle.Messages.Failed';

        return Messages;

    })(WishlistArticle.Messages || {});

        return WishlistArticle;

    })(Vendd.WishlistArticle || {});

return Vendd;

})(Vendd || {});